jQuery(document).ready(function ($) {
  if (jQuery('body.woocommerce-cart').length) {
    jQuery(document).on('change', '.woocommerce-cart-form .cart_item .qty', function () {
      updateCart = setTimeout(function () {
        jQuery('button[name=\'update_cart\']').trigger('click');
      }, 1200);
    });
  }
});